module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-04-5ea76cd1ee311011bce18f723b090edf.jpg";